import React from 'react';
import { ToggleSwitchField } from 'shared/containers/portal_layout/HForm';

const SlotRestrictionsFields = () => (
  <div>
    <ToggleSwitchField
      name="permitSelfReferral"
      label="Allow self-referral patients to book this slot?"
      showStateLabel
      onStateLabel="Yes"
      offStateLabel="No"
    />
    <ToggleSwitchField
      name="highPriorityOnly"
      label="Reserve slot for high-priority referrals?"
      showStateLabel
      onStateLabel="Yes"
      offStateLabel="No"
    />
  </div>
);

SlotRestrictionsFields.displayName = 'SlotRestrictionsFields';

export default SlotRestrictionsFields;
